<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            class=""
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab></settings-tab>
      <div class="row">
        <others-sidebar></others-sidebar>
        <div class="col-xl-9">
          <div class="card">
            <div class="card-header px-0 mx-3">
              <div class="d-flex align-items-center justify-content-between">
                <h4>Ban IP Address</h4>
                <a
                  href="javascript:void(0);"
                  class="btn btn-primary btn-sm d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add_ban"
                  @click="prepareAdd"
                >
                  <i class="ti ti-circle-plus me-2"></i>Add IP Address
                </a>
              </div>
            </div>
            <div class="card-body pb-0">
              <div class="row bx-3">
                <div v-if="loading" class="col-12 mb-3">
                  <p class="mb-0">Loading banned IPs...</p>
                </div>
                <div
                  v-if="!loading && !rows.length"
                  class="col-12 mb-3 text-muted"
                >
                  No banned IPs yet. Click "Add IP Address" to create one.
                </div>

                <div class="col-lg-6" v-for="item in rows" :key="item.id">
                  <div class="card mb-3">
                    <div class="card-body">
                      <div
                        class="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2"
                      >
                        <div class="d-flex align-items-center">
                          <span class="d-inline-flex me-2">
                            <i class="ti ti-ban"></i>
                          </span>
                          <p class="fs-14 fw-medium text-dark mb-0">
                            {{ item.ip_address }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center">
                          <a
                            href="javascript:void(0);"
                            class="link-default me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_ban"
                            @click="setEditing(item)"
                          >
                            <i class="ti ti-edit"></i>
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="link-default"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_modal"
                            @click="setEditing(item)"
                          >
                            <i class="ti ti-trash"></i>
                          </a>
                        </div>
                      </div>
                      <div>
                        <p class="mb-1">
                          <span class="me-2">
                            <i class="ti ti-info-circle"></i>
                          </span>
                          {{ item.reason || "Blocked for security reasons." }}
                        </p>
                        <p class="mb-0 text-muted fs-12">
                          Created:
                          {{ formatDateTime(item.created_at) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ban-modal is globally wired to the bannedIp store -->
            </div>
          </div>
        </div>
      </div>
    </div>
     <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <ban-modal></ban-modal>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useBannedIpStore } from "@/stores/settings/banned-ip.store";

const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const bannedIpStore = useBannedIpStore();

const loading = computed(() => bannedIpStore.loading);
const rows = computed(() => bannedIpStore.rows);

function toggleHeader() {
  document.getElementById("collapse-header").classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function prepareAdd() {
  // clear current when adding
  bannedIpStore.setCurrent(null);
}

function setEditing(item) {
  bannedIpStore.setCurrent(item);
}

function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString();
}

onMounted(() => {
  bannedIpStore.fetchList();
});
</script>


